/** The durable session is authoritative. This secondary legacy index has only
 * (workout_log_id, exercise_name), so it cannot represent a name with multiple
 * muscles or units. Such names are omitted rather than silently relabelled. */
export interface FitnessExerciseLogIndexInput {
  readonly name: string; readonly muscle: string; readonly timed: boolean; readonly sets: readonly unknown[];
}
export interface FitnessExerciseLogIndexEntry {
  name: string; muscle: string; timed: boolean; sets: unknown[]; orderIndex: number;
}
export function buildFitnessExerciseLogIndex(exercises: readonly FitnessExerciseLogIndexInput[]) {
  const entries = new Map<string, FitnessExerciseLogIndexEntry>(), ambiguous = new Set<string>();
  exercises.forEach((exercise, index) => {
    if (ambiguous.has(exercise.name)) return;
    const previous = entries.get(exercise.name);
    if (previous && (previous.muscle !== exercise.muscle || previous.timed !== exercise.timed)) {
      entries.delete(exercise.name); ambiguous.add(exercise.name); return;
    }
    if (previous) previous.sets.push(...exercise.sets);
    else entries.set(exercise.name, { name: exercise.name, muscle: exercise.muscle, timed: exercise.timed,
      sets: [...exercise.sets], orderIndex: index });
  });
  return { entries: [...entries.values()], ambiguousCount: ambiguous.size };
}
